<template>
    <div class="bar-calendar-select" :class="containerClass">
        <div class="title_container" v-if="inMore">
            <div class="title_calendar">{{ label }}</div>
        </div>
        <div class="content" :class="contentClass">
            <div class="item">
                <date-picker
                    v-model:date="minVal"
                    :placeholder="minTitle"
                    valueFormat="timestamp"
                    format="MM/dd/yyyy"
                />
            </div>
            <div class="split"></div>
            <div class="item">
                <date-picker
                    v-model:date="maxVal"
                    :placeholder="maxTitle"
                    valueFormat="timestamp"
                    format="MM/dd/yyyy"
                />
            </div>
        </div>
    </div>
</template>

<script>
import classNames from 'classnames';
import DatePicker from '../../../../components/date-picker';
import mixins from './mixins';
export default {
    emits: ['update:value'],
    name: 'CalendarSelectPc',
    mixins: [mixins],
    watch: {
        value() {
            this.minVal = this.value.split(',')[0] || '';
            this.maxVal = this.value.split(',')[1] || '';
        },
        minVal() {
            this.$nextTick(() => {
                this.setValue();
            });
        },
        maxVal() {
            this.$nextTick(() => {
                this.setValue();
            });
        }
    },
    computed: {
        containerClass() {
            return classNames(this.theme);
        },
        contentClass() {
            return classNames(this.theme);
        }
    },
    data: function() {
        return {
            minVal: this.value.split(',')[0] || '',
            maxVal: this.value.split(',')[1] || ''
        };
    },
    methods: {
        setValue() {
            if (this.maxVal && this.minVal > this.maxVal) {
                this.$emit(
                    'update:value',
                    `${this.formatMaxValue(
                        this.maxVal,
                        'min'
                    )},${this.formatMaxValue(this.minVal, 'max')}`
                );
            } else {
                this.$emit(
                    'update:value',
                    `${this.formatMaxValue(
                        this.minVal,
                        'min'
                    )},${this.formatMaxValue(this.maxVal, 'max')}`
                );
            }
        }
    },
    components: {
        'date-picker': DatePicker
    }
};
</script>

<style lang="scss">
.bar-calendar-select {
    &.standard {
        color: #515666;
        font-size: 14px;
        .title_container {
            .advance {
                color: var(--g-btn-background);
            }
        }
        .el-input__inner {
            color: #202437;
        }
    }
    &.template1 {
        font-size: 14px;
        color: #282828;
        .title_container {
            .advance {
                color: var(--g-btn-background);
            }
        }
        .el-input__inner {
            color: #202437;
        }
    }
    &.template4 {
        font-size: 17px;
        color: #6b7282;
        .title_container {
            .advance {
                color: var(--g-btn-background);
            }
        }
        .el-input__inner {
            color: #4a4a60;
        }
    }
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
        width: 100%;
    }
    .title_container {
        margin-bottom: 10px;
    }
    .content {
        height: 40px;
        display: flex;
        align-items: center;
        justify-items: flex-start;
        .item {
            height: 100%;
            flex: 1 0 0;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }
        .split {
            margin: 0 10px;
            height: 100%;
            width: 10px;
            position: relative;
            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 50%;
                width: 100%;
                height: 1px;
            }
        }
        &.standard {
            .split {
                &::before {
                    background: #c6c8d1;
                }
            }
        }
        &.template1 {
            .split {
                &::before {
                    background: #dde0ec;
                }
            }
        }
        &.template4 {
            .split {
                &::before {
                    background: #c6c8d1;
                }
            }
        }
    }
}

</style>
